import {Container} from '@/components/ui/container/Container'
import {Divider} from '@/components/ui/divider/Divider'
import {useTheme} from 'styled-components'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {useTranslation} from '@/translations/i18n'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {useMemo} from 'react'
import {
    StyledProPhotosSkeletonGrid,
    StyledProPhotosServicesSkeletonGrid,
    StyledProPhotosHeader,
    StyledProPhotosTitleWrapper
} from './style'
import {ProPhotosGrid} from '../pro-photos-grid/ProPhotosGrid'

interface ProPhotosSkeletonProps {
    title: string
    description: string
    serviceTitle: string
}

export const ProPhotosSkeleton = ({title, description, serviceTitle}: ProPhotosSkeletonProps) => {
    const {palette} = useTheme()
    const {t} = useTranslation()
    const skeletonItems = useMemo(() => Array.from({length: 9}), [])
    return (
        <ScrollArea scrollbar={<Scrollbar />}>
            <Container fullWidth fullHeight={false}>
                <StyledProPhotosHeader gap={2} align="center">
                    <h1>{title}</h1>
                    <p>{description}</p>
                </StyledProPhotosHeader>
            </Container>

            <Divider direction="horizontal" background={palette.neutral[300]} />

            <ProPhotosGrid
                leftSlot={
                    <StyledProPhotosTitleWrapper align="center">
                        <h3>{t('vetting:reordering:gallery')}</h3>
                    </StyledProPhotosTitleWrapper>
                }
                rightSlot={
                    <StyledProPhotosTitleWrapper align="center">
                        <h3>{serviceTitle}</h3>
                    </StyledProPhotosTitleWrapper>
                }
            />

            <Divider direction="horizontal" background={palette.neutral[300]} />

            <ProPhotosGrid
                leftSlot={
                    <StyledProPhotosSkeletonGrid>
                        {skeletonItems.map((_, index) => (
                            <Skeleton
                                key={index}
                                width="100%"
                                height="100%"
                                style={{borderRadius: '8px', aspectRatio: '1/1'}}
                            />
                        ))}
                    </StyledProPhotosSkeletonGrid>
                }
                rightSlot={
                    <StyledProPhotosServicesSkeletonGrid gap={4} direction="column" fullWidth>
                        <Skeleton height={100} />
                        <Skeleton height={100} />
                        <Skeleton height={100} />
                    </StyledProPhotosServicesSkeletonGrid>
                }
            />
        </ScrollArea>
    )
}
ProPhotosSkeleton.displayName = 'ProPhotosSkeleton'
